import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoursesService } from '@draeger-academy/common';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { Course } from 'models/course';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'da-tab-section',
    templateUrl: './tab-section.component.html',
    styleUrls: ['./tab-section.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabSectionComponent implements OnInit {
    @Input() data;
    @Input() site;
    public course: Course = null;

    public description: any;
    public url: string;
    public showEventTab: boolean;
    public language: boolean;
    public noCourseForRequiredQualificationsText: string;
    private _$showDownload: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showNoCourseForRequiredQualifications: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showDownload$(): Observable<boolean> {
        return this._$showDownload.asObservable();
    }
    public get showNoCourseForRequiredQualifications$(): Observable<boolean> {
        return this._$showNoCourseForRequiredQualifications.asObservable();
    }
    
    public accordion: any;
    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        private _configurationService: ConfigurationService,
        private _translateService: TranslateService,
        private _courseService: CoursesService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        if (this.data) {
            this.accordion = {
                isRequiredQualification: Boolean(this.data.hasRequiredQualifications),
                itemList: [],
                isOpen: true
            };
            if (this.data.hasRequiredQualifications && this.data.requiredQualifications?.length > 0) {
                this.accordion.itemList.push({
                    copytext: {
                        value: this.data.requiredQualifications
                    }
                });
                if (this.data.requiredQualifications.flatMap(rq => rq.mediatingCourses).length === 0) {
                    this._$showNoCourseForRequiredQualifications.next(true);
                }
                const noCourseTranslation = this._translateService.instant('booking.checkoutList.requiredQualificationsNoCourseText');  
                this.noCourseForRequiredQualificationsText = noCourseTranslation.split('{{name}}').join(``);
            }

            this.course = new Course(this.data);
            if (this.course && this.course.events && this.course.events.length > 0) {
                this.showEventTab = true;
            } else {
                this.showEventTab = false;
            }
        }
        this.setCourseDescription();
        this._courseService.languageSelected.subscribe((language) => {
            this.setCourseDescription();
        });

        this._$showDownload.next(this._configurationService.hasFeature('DownloadCourseDescription'));

        if (this.course && this.course.id) {
            this.url = `${environment.APIEndpoint}api/v1/course/getcoursedescription/${this.course.id}`;
        }

        this.route.fragment.subscribe((fragment) => {
            if (fragment && fragment === 'prerequisites') {
                setTimeout(() => {
                    this.scrollToId('prerequisites');
                }, 10);
            }
        });
    }

    scrollToId(id: string): void {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    private setCourseDescription() {
        if (this.course && this.course.training && this.course.training.description) {
            this.description = this.course.training.trainingDescriptions;
        }

        const site = this._configurationService.getSiteFromUrl();
        if (site) {
            this.site = site.site;
            this.language = this.site.split('_')[0];
        }
        if (this._configurationService.isPartnerPage()) {
            this.language = JSON.parse(sessionStorage.getItem('portalLang'))?.lang;
            this.site = JSON.parse(sessionStorage.getItem('portalLang'))?.portalId;
        }
        const newDescription = [];

        if (this.description && this.description.length > 0) {
            for (const desc of this.description) {
                if (desc.languageKey === this.language) {
                    newDescription.push(desc);
                }
            }
            if (newDescription.length === 0) {
                for (const desc of this.description) {
                    if (desc.languageKey === this.course.language) {
                        newDescription.push(desc);
                    }
                }
            }

            this.description = newDescription;
        }
    }
}
